import React from 'react'
import { TcomputedKeyParam } from '../../shared/types/computedKeyParam.type'
import {
    Box,
    FormControl,
    ListSubheader,
    MenuItem,
    Select,
    Typography
} from '@mui/material'
import { capitalize, get, toNumber } from 'lodash'
import { useTranslation } from 'react-i18next'

ParamSection.defaultProps = {
    hideSelect: false
}

function ParamSection({
    keyParam,
    groupedKeys,
    onChangekey,
    hideSelect,
    selectedKeys
}: {
    keyParam: TcomputedKeyParam,
    groupedKeys?: Record<string, TcomputedKeyParam[]>,
    onChangekey?: (newId: string, oldParam: TcomputedKeyParam) => void,
    hideSelect?: boolean,
    selectedKeys?: string[]
}) {

    const { t } = useTranslation()
    const getUnits = (unit: string, value: string) => {
        if (["mm:ss.ms", "hh:mm:ss"].includes(unit)) return ""
        if (unit === "s") return toNumber(value) <= 60 ? "s" : ""
        return unit
    }

    const getText = () => {
        let value = get(keyParam, "formatted_value", "")
        let unit = get(keyParam, "key_parameter_layout.insight_parameter.unit_translated", "")

        if (!value) return "-"
        return value + " " + getUnits(unit, value)
    }

    const selectedValue = String(
        keyParam?.key_parameter_layout?.insight_parameter?.["@id"] ?? ""
    )

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            height="100%"
        >
            {/* TOP DISPLAY */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
                flex={1}
            >
                <div className="icon">
                    <span className={`eq-${keyParam?.key_parameter_layout?.insight_parameter?.icon} eq-icon-2`}>
                        <span className="path1"></span>
                        <span className="path2"></span>
                        <span className="path3"></span>
                        <span className="path4"></span>
                        <span className="path5"></span>
                        <span className="path6"></span>
                        <span className="path7"></span>
                        <span className="path8"></span>
                    </span>
                </div>

                <Typography variant="body2" fontSize="16px">
                    {getText()}
                </Typography>

                <Typography
                    variant="body2"
                    color="lightgray"
                    textAlign="center"
                >
                    {get(
                        keyParam,
                        "key_parameter_layout.insight_parameter.name_translated",
                        ""
                    )}
                </Typography>
            </Box>

            {/* SELECT */}
            {!hideSelect && (
                <FormControl sx={{ m: 1, minWidth: 120, maxWidth: 200 }} size="small">
                    <Select
                        id="grouped-select"
                        value={selectedValue}
                        onChange={(e) =>
                            onChangekey?.(e.target.value, keyParam)
                        }
                    >
                        {/* SINGLE CLEAR OPTION */}
                        <MenuItem value="">
                            <em> </em>
                        </MenuItem>

                        {/* GROUPED OPTIONS */}
                        {groupedKeys &&
                            Object.entries(groupedKeys).flatMap(([groupName, values]) => [
                                <ListSubheader key={groupName}>
                                    {capitalize(t(`dataParameters:groups:${groupName}`))}
                                </ListSubheader>,

                                ...values.map((valueItem) => {
                                    const id = String(
                                        valueItem.key_parameter_layout.insight_parameter["@id"]
                                    )

                                    return (
                                        <MenuItem
                                            key={id}
                                            value={id}
                                            disabled={selectedKeys?.includes(id)}
                                        >
                                            <Typography
                                                variant="body2"
                                                textOverflow="ellipsis"
                                                whiteSpace="nowrap"
                                                overflow="hidden"
                                            >
                                                {
                                                    valueItem.key_parameter_layout
                                                        .insight_parameter.name_translated
                                                }
                                            </Typography>
                                        </MenuItem>
                                    )
                                })
                            ])
                        }
                    </Select>
                </FormControl>
            )}
        </Box>
    )
}

export default ParamSection
